import { useCallback } from 'react'

import { stopPropagation } from '../../../../../utils/events'
import { AttachServiceRequestsModal } from '../../../../Request'

import { getAttachedRelatedServiceRequests } from './useEmailProfileMessageAttachedRequests.api'

export function useEmailProfileMessageAttachedRequests({
  uuid,
  onCloseModal,
  onSetModal,
}) {
  const handleClickAttachedRequests = useCallback(
    event => {
      stopPropagation(event)

      onSetModal(
        <AttachServiceRequestsModal
          readonly
          actionsProps={{
            ButtonCancel: null,
            buttonAttachProps: {
              text: 'Modal.ConfirmBtnKey',
            },
          }}
          counterProps={{
            text: 'Modal.AttachedRequestsCountBtnKey',
          }}
          entityId={uuid}
          headerProps={{
            text: 'Modal.AttachedRequestsTitleKey',
          }}
          loadItems={getAttachedRelatedServiceRequests}
          onClose={onCloseModal}
        />
      )
    },
    [onCloseModal, onSetModal, uuid]
  )

  return {
    handleClickAttachedRequests,
  }
}
